var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-nav-item',{attrs:{"to":_vm.to,"title":_vm.title}},[_c('v-icon',{attrs:{"name":_vm.icon,"width":"16"}}),_c('span',{staticClass:"sm-hidden"},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }